import appliedIntelligence from './appliedIntelligence'

export default {
  transformation: {
    ...appliedIntelligence,
  },
}
